/* --- COMMUNICATIONS MODULE --- */
export const GET_SELECTED_COMMUNICATION = "GET_SELECTED_COMMUNICATION";
export const GET_COMMUNICATION = "GET_COMMUNICATION";
export const GET_COMMUNICATIONS_LIST = "GET_COMMUNICATIONS_LIST";
export const GET_COMMUNICATIONS_LOADING = "GET_COMMUNICATIONS_LOADING";


